import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'

export interface RequestErrorStatusCardProps extends PropsWithChildren {
  title?: string
  sentryEventId?: string
  onReload?: () => void
}

export const RequestErrorStatusCard = ({
  title,
  children,
  sentryEventId,
  onReload,
}: RequestErrorStatusCardProps) => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="error-state"
      LottiePlayer={<Lottie src="connection-error" />}
      title={title ?? t('errorMessages.getErrorTitle')}
      description={
        <>
          {children ?? (
            <p className="text-body-regular text-foreground-prominent text-center">
              {`${t('errorMessages.weApologiseForInconvenience')} ${t('errorMessages.pleaseTryTo')} `}
              {onReload ? (
                <Button variant="ghost" noPadding onClick={onReload}>
                  {t('errorMessages.reloadData')}
                </Button>
              ) : (
                <Button variant="ghost" noPadding onClick={() => window.location.reload()}>
                  {t('errorMessages.reload')}
                </Button>
              )}
              {`. ${t('errorMessages.ifTheProblemPersists')}, `}
              <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
                {t('errorMessages.contactSupport')}
              </ExternalLink>
              {` ${t('errorMessages.tryLater')}.`}
            </p>
          )}
          {sentryEventId && (
            <p className="text-body-regular-small text-foreground-subdued pt-6">
              {t('errorMessages.eventId')}: {sentryEventId}
            </p>
          )}
        </>
      }
    />
  )
}
